export default __webpack_public_path__ + "static/card-3-ef677107f017ec93b8a8022cd7f5cf04.png";